<template>
  <div class="voice-container relative">
    <div class="absolute w-48 h-48">
        <div class="absolute top-1/2 left-1/2 rounded-full flex items-center justify-center text-white text-3xl transform -translate-x-1/2 -translate-y-1/2 shadow-lg z-10">
          <div class="water-round-container">
            <div class="water-wave1"></div>
            <div class="water-wave2"></div>
            <div class="water-wave3"></div>
          </div>
        </div>
      </div>    
    <div id="bars" v-if="isSpeaking">
      <div class="bar"></div>
      <div class="bar"></div>
      <div class="bar"></div>
      <div class="bar"></div>
      <div class="bar"></div>
      <div class="bar"></div>
      <div class="bar"></div>
      <div class="bar"></div>
      <div class="bar"></div>
      <div class="bar"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "VoiceAnimation",
  props: {
    isSpeaking: {
      type: Boolean,
      required: true,
    },
  },
}
</script>

<style scoped>
.voice-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: auto;
  margin-bottom: auto;
}

#bars {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: auto;
  margin-bottom: auto;
}

.bar {
    background: #e59230;
    bottom: 1px;
    height: 3px;
    width: 10px;
    margin: 0px 4px;
    border-radius: 5px;
    animation: sound 0ms -600ms linear infinite alternate;
}

@keyframes sound {
    0% {
       opacity: .35;
        height: 3px; 
    }
    100% {
        opacity: 1;       
        height: 70px;        
    }
}

.bar:nth-child(1)  { left: 1px; animation-duration: 474ms; }
.bar:nth-child(2)  { left: 15px; animation-duration: 433ms; }
.bar:nth-child(3)  { left: 29px; animation-duration: 407ms; }
.bar:nth-child(4)  { left: 43px; animation-duration: 458ms; }
.bar:nth-child(5)  { left: 57px; animation-duration: 400ms; }
.bar:nth-child(6)  { left: 71px; animation-duration: 427ms; }
.bar:nth-child(7)  { left: 85px; animation-duration: 441ms; }
.bar:nth-child(8)  { left: 99px; animation-duration: 419ms; }
.bar:nth-child(9)  { left: 113px; animation-duration: 487ms; }
.bar:nth-child(10) { left: 127px; animation-duration: 442ms; }

.water-round-container {
  margin: 0 auto;
  overflow: hidden;
  position: relative;
  width: 200px;
  height: 200px;
  border-radius: 50%;
  border: 3px solid #fdba74;
  text-align: center;
  line-height: 50px;
  animation: water-waves linear infinite;
}
.water-wave1 {
  position: absolute;
  top: 40%;
  left: -25%;
  background: #FFA726;
  opacity: 0.7;
  width: 200%;
  height: 200%;
  border-radius: 40%;
  animation: inherit;
  animation-duration: 5s;
}

.water-wave2 {
  position: absolute;
  top: 45%;
  left: -35%;
  background: #FFB74D;;
  opacity: 0.5;
  width: 200%;
  height: 200%;
  border-radius: 35%;
  animation: inherit;
  animation-duration: 7s;
}

.water-wave3 {
  position: absolute;
  top: 50%;
  left: -35%;
  background: #F57C00;
  opacity: 0.3;
  width: 200%;
  height: 200%;
  border-radius: 33%;
  animation: inherit;
  animation-duration: 11s;
}

@keyframes water-waves {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
